import { gql } from '@apollo/client';

export const VEHICLES = gql`
  query Vehicles($data: VehiclesRequestParams!) {
    vehicles(data: $data) {
      results {
        id
        licensePlate
        categories
        vehicleMake {
          name
        }
        vehicleModel {
          name
        }
        vehicleSeries {
          name
        }
        active
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const VEHICLE_CHARACTERISTICS =  gql`
  query VehicleCharacteristics($make: VehicleMakeParamsInput!, $model: VehicleModelParamsInput!, $series: VehicleSeriesParamsInput!) {
    vehicleMakes(data: $make) {
      results {
        id
        name
      }      
    }
    vehicleModels(data: $model) {
      results {
        id
        vehicleMakeId
        name
      }      
    }
    allVehicleSeries(data: $series) {
      results {
        id
        vehicleModelId
        name
      }
    }
  }
`;

export const CREATE_VEHICLE = gql`
  mutation CreateVehicle($data: VehicleInput!) {
    createVehicle(data: $data) {
      id
    }
  }
`;

export const UPLOAD_VEHICLE_PHOTO = gql`
  mutation UploadVehiclePhoto($id: Int!, $file: Upload!) {
    uploadVehiclePhoto(id: $id, file: $file)
  }
`;

export const VEHICLE = gql`
  query Vehicle($id: Int!) {
    vehicle(id: $id) {
      id
      fleetId
      categories
      capacityPassengers
      capacityLuggage
      childSeatOption
      color
      licensePlate
      vehicleMakeId
      vehicleModelId
      vehicleSeriesId
      active
      manufactureYear
      photoFileId
      excludedTravelAddons
      vehicleMake {
        name
      }
      vehicleModel {
        name
      }
      vehicleSeries {
        name
      }
      photoFile {
        externalKey
        contentType
      }
      fleet {
        transferCompanyId
      }
    }
  }
`;

export const UPDATE_VEHICLE = gql`
  mutation UpdateVehicle($data: VehicleInput!) {
    updateVehicle(data: $data)
  }
`;

export const REMOVE_VEHICLE = gql`
  mutation RemoveVehicle($id: Int!) {
    removeVehicle(id: $id)
  }
`;
